<template>
    <CardBase
        :config="content"
        :card-type="'teaser'"
    />
</template>

<script setup lang="ts">
import type { HblSlot } from '@/utils/types'

const props = defineProps<{
    content: HblSlot,
}>()
</script>